import { twMerge } from 'tailwind-merge';
import { ProductCardProps } from '../../types';

export default function CardBodyPreSale(props: Partial<ProductCardProps>) {
  const { data } = props;
  const { delivery_desc = '' } = data || {};

  if (!!delivery_desc) {
    return (
      <div
        data-testid="wid-product-card-pre-sale-date"
        onClick={e => e.stopPropagation()}
        className={twMerge(
          'mb-1 max-w-full whitespace-nowrap overflow-hidden leading-4 flex items-center ',
          'enki-body-2xs-medium text-surface-100-fg-minor'
        )}
        dangerouslySetInnerHTML={{ __html: delivery_desc }}></div>
    );
  }
  return null;
}
